import axios from 'axios';

export const BASE_URL = "https://immersive-game-india.confirmu.com";

export let headers = {
  'Tenant-Access-Token': 'MmNlMDNhYzY0ZGVkMDJmMDM2MWZjYTk2OGNmMGJjYTM=',
  'Tenant-Access-Key': 'RoDGcKc6X7SwYg',
};

export const api = axios.create({
  baseURL: BASE_URL,
  headers: headers
});